function arrayMove(array, fromIndex, toIndex) {
  const new_array = [...array];
  var element = new_array[fromIndex];
  new_array.splice(fromIndex, 1);
  new_array.splice(toIndex, 0, element);
  return new_array;
}
export default arrayMove;
